import { connect } from 'react-redux';

import {
  getFunnelExecutionResult,
  getSelectedFunnel,
  getMyPermissions,
} from '../../../reducers/analyticsApp';
import { staticPermissions } from '../../../constants/authorization';
import FunnelExecutionSummaryGrid from '../../../components/funnel/execution/SummaryGrid';
import { deleteFunnel, duplicateFunnel, startUpdateFunnel } from '../../../actions/funnel';

const mapStateToProps = (state) => {
  const result = getFunnelExecutionResult(state);
  const funnel = getSelectedFunnel(state);
  const hasPermission = getMyPermissions(state).has(staticPermissions.FUNNEL_MANAGE);

  if (!result) {
    return {
      item: funnel,
      preview: true,
      hasPermission,
    };
  }

  return {
    item: funnel,
    started: result.started,
    conversion: result.conversion,
    completed: result.completed,
    optionalConversion: result.optionalConversion,
    optionalCompleted: result.optionalCompleted,
    hasPermission,
  };
};

const mapDispatchToProps = (dispatch, { navigate, tenantId }) => ({
  onDelete: (item) => {
    dispatch(deleteFunnel(item.id));
  },
  onUpdate: (item) => {
    dispatch(startUpdateFunnel(item));
    navigate(`/${tenantId}/funnels/update/${item.id}`);
  },
  onDuplicate: (item) => {
    dispatch(duplicateFunnel(item));
    navigate(`/${tenantId}/funnels/add`);
  },
  showExposureSQLButton: true,
});

export default connect(mapStateToProps, mapDispatchToProps)(FunnelExecutionSummaryGrid);
